import {jsonMember, jsonObject} from "typedjson";

export interface IPitFinancingRedistributionBySourceLite {
  _id: number;
  _year: number;
  redistributionSum: number;
  financingItemId: number;
  financingItemSrcId: number;
}

@jsonObject
export class PitFinancingRedistributionBySourceLite implements IPitFinancingRedistributionBySourceLite {

  /** Уникальный идентификатор строки перераспределения финансирования между мероприятиями по источникам */
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  _id: number;

  /** Год финансирования */
  @jsonMember({name: "year", constructor: Number, emitDefaultValue: false, isRequired: false })
  _year: number;

  /** Сумма перераспределения */
  @jsonMember({name: "redistributionSum", constructor: Number, emitDefaultValue: false, isRequired: false })
  redistributionSum: number;

  @jsonMember({name: "financingItemId", constructor: Number, emitDefaultValue: false, isRequired: false })
  financingItemId: number;

  @jsonMember({name: "financingItemSrcId", constructor: Number, emitDefaultValue: false, isRequired: false })
  financingItemSrcId: number;

}
